import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@modules/auth/services/auth.service';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';
import { filter, first, map } from 'rxjs';

const ROTA_TROCA_OBRIGATORIA = '/trocar-senha-obrigatoria';

export const trocaSenhaObrigatoriaGuard: CanActivateFn = (_route, state) => {
  const usuariosService = inject(UsuariosService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Evita loop: se o destino já é a rota de troca, deixa passar
  if (state.url.startsWith(ROTA_TROCA_OBRIGATORIA)) {
    return true;
  }

  // Se não autenticado, deixa o authGuard lidar — não bloqueia a navegação
  if (!authService.estaAutenticado) {
    return true;
  }

  // Aguarda o perfil chegar (pode ser null no início, antes do carregamento assíncrono)
  return usuariosService.usuarioLogado$.pipe(
    filter((u) => u !== null),
    first(),
    map((perfil) => {
      if (perfil!.deveTrocarSenha === true) {
        return router.createUrlTree([ROTA_TROCA_OBRIGATORIA]);
      }
      return true;
    }),
  );
};
